<template>
    <div class="heart-form grg40">
        <div class="hearts input-group one grg20">
            <input class="form-control" type="text" :value="heartSize">
            <radio-component v-model="heartSize" :radioOptions="radioOptions" class-name="recur" name="heartSize" :value="heartSize"></radio-component>
        </div>
        <donation-form :preload="true" :preloadedDonation="donation" :useCustomAmount="true" :customAmount="parseInt(heartSize)" :chosen="heartSize"></donation-form>
    </div>
</template>

<script>
    import RadioComponent from "./RadioComponent";

    export default {
        name: "HeartForm",
        components: {
            RadioComponent
        },
        data: () => ({
            heartSize: '0',
            donation: {
                dedicate: '0',
                final_currency: 'ZAR'

            },
            radioOptions:
                [
                    {
                        label: '6cm heart (max 12 characters)',
                        value: '180',
                        id: '180',
                        checked: true
                    },
                    {
                        label: '7cm heart (max 14 characters)',
                        value: '360',
                        id: '360',
                        checked: false
                    },
                    {
                        label: '8cm heart (max 16 characters)',
                        value: '540',
                        id: '540',
                        checked: false
                    },
                    {
                        label: '9cm heart (max 18 characters)',
                        value: '720',
                        id: '720',
                        checked: false
                    },
                    {
                        label: '10cm heart (max 20 characters)',
                        value: '900',
                        id: '900',
                        checked: false
                    },
                    {
                        label: '11cm heart (max 30 characters)',
                        value: '1080',
                        id: '1080',
                        checked: false
                    },
                    {
                        label: '12cm pearl heart (max 40 characters)',
                        value: '1800',
                        id: '1800',
                        checked: false
                    },
                    {
                        label: '13cm silver heart (max 50 characters)',
                        value: '2700',
                        id: '2700',
                        checked: false
                    },
                    {
                        label: '14cm gold heart (max 60 characters)',
                        value: '3600',
                        id: '3600',
                        checked: false
                    },
                    {
                        label: '15cm platinum heart (max 70 characters)',
                        value: '5400',
                        id: '5400',
                        checked: false
                    },
                    {
                        label: 'R5400+ customized heart',
                        value: '5401',
                        id: '5401',
                        checked: false
                    },
                ],

        })
    }
</script>

<style scoped>

</style>
